"use strict";

var _defineProperty = require("/codebuild/output/src1459256663/src/fans/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/codebuild/output/src1459256663/src/fans/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paramsToObject = exports.objectToParams = exports.isObject = void 0;
var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
exports.isObject = isObject;
/** Encode object to url parameters */
var objectToParams = function objectToParams(obj) {
  if (!(0, exports.isObject)(obj) || Object.keys(obj).length === 0) {
    return '';
  }
  return '?' + Object.keys(obj).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(obj[key]));
  }).join('&');
};
exports.objectToParams = objectToParams;
/** Decode params to object */
var paramsToObject = function paramsToObject(params) {
  return (params === null || params === void 0 ? void 0 : params.replace(/^\?/, '').split('&').reduce(function (acc, chunk) {
    if (!chunk) {
      return acc;
    }
    var _chunk$split = chunk.split('='),
      _chunk$split2 = _slicedToArray(_chunk$split, 2),
      key = _chunk$split2[0],
      value = _chunk$split2[1];
    return Object.assign(Object.assign({}, acc), _defineProperty({}, key, decodeURIComponent(value)));
  }, {})) || {};
};
exports.paramsToObject = paramsToObject;